<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-input sm="2" invalidFeedback="Informe o início do tombamento" description=""
                        v-model="form.numTombamentoDe" label="Tombamento:"  />

                    <lg-form-input sm="2" invalidFeedback="Informe o fim do tombamento" description=""
                        v-model="form.numTombamentoAte" label="Até:"  />

                    <lg-form-date sm="2" invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataDe" label="Entrada:" />
                    <lg-form-date sm="2" invalidFeedback="A data limite deve ser informada!" description=""
                        v-model="form.dataAte" label="Até:" />

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageTipoEstadoConservacao id="finderTipoEstadoConservacao" @input="selectTipoEstado"
                            v-model="form.tipoestadoconservacao" :prefix="[prefix + title]" :isModal="true">
                        </LgFinderPageTipoEstadoConservacao>
                    </b-col>

                    <lg-form-input invalidFeedback="Informe um tombamento válido" description="" sm="4"
                        v-model="form.numTombamentoSamp" label="Tombamento SAMP:" maxlength="10" />

                    <lg-form-input sm="4" invalidFeedback="Informe um complemento válido" description=""
                        v-model="form.complemento" label="Dado complementar:" />

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageEmpenho @input="selectEmpenho" v-model="form.empenho" :value="form.empenho"
                            label="Empenho:" id="finderEmpenho" invalidFeedback="A empresa deve ser informada!"
                            description="" :prefix="[prefix + title]" />
                    </b-col>

                    <lg-form-input sm="4" lg="4" invalidFeedback="O número processo deve ser informado!" description=""
                        v-model="form.numeroProcesso" label="Nº Processo:" />

                    <b-col lg="4" sm="12" class="text-left">

                        <LgFinderPageUnidadeAdministrativa id="finderDepartamentoIBP" v-model="form.departamento"
                            @notInUnidadeAdministrativa="manageNotInUnidadeAdministrativa"
                            @selecionarOrnograma="selecionarOrnograma" @onselect="departamentoSelect"
                            :podeMudarDepartamento="podeMudarDepartamento" :codsDepartamentos="codsDepartamentos"
                            :podeApagarDepartamento="podeMudarDepartamento"
                            :mostrarNotInUnidadeAdministrativa="verificaPrivilegioGerenciarPatrimonio()"
                            :ornograma="verificaPrivilegioGerenciarPatrimonio()" :prefix="prefix + title + ' > '">
                        </LgFinderPageUnidadeAdministrativa>
                    </b-col>


                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageModelo v-model="form.modelo" :prefix="[prefix + title]" @input="selectModelo"
                            id="finderPageModelo" label="Modelo:" invalidFeedback="Modelo deve ser informado!" />
                    </b-col>

                    <lg-form-input sm="4" invalidFeedback="Informe um número de contrato válido!" description=""
                        v-model="form.nroContrato" label="Nº Contrato:" />

                    <b-col lg="4" sm="12" class="text-left">

                        <lg-finder-page-local-armazenamento @selectFillhoClicked="selectFillhoClicked"
                            :mostrarIncluirFilhos="true" id="finderPageArmazenamento" @input="localArmazenamentoSelect"
                            v-model="form.localArmazenamento" :prefix="prefix + title + ' > '" />

                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageMarca v-model="form.marca" @input="marcaSelect" :prefix="[prefix + title]"
                            id="finderPageMarca" label="Marca:" invalidFeedback="Marca deve ser informada!" cols="12" />

                    </b-col>
                    <lg-form-input sm="4" invalidFeedback="Informe uma descrição válida" description=""
                        v-model="form.descricaoProduto" label="Descrição:" />

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageNatureza v-model="form.natureza" @input="naturezaSelect" :prefix="[prefix + title]"
                            id="finderPageNatureza" label="Natureza:" invalidFeedback="Marca deve ser informada!"
                            cols="12" fromItemBemPermanenteList />
                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPagePessoa v-model="form.responsavel" @onselect="responsavelSelect"
                            @onClear="responsavelSelect" :prefix="prefix + title + ' > '" id="finderPagePessoa"
                            label="Utilizado por:" cols="12" />

                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <b-col cols="12" class="text-left">
                            <b-form-checkbox v-model="form.descricaoExata" :value="true" :unchecked-value="false">
                                Descrição exata
                            </b-form-checkbox>
                        </b-col>

                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageStatus v-model="form.status" id="finderPageStatus" @input="selectStatus"
                            :prefix="[prefix, title]" label="Status:" cols="12" />
                    </b-col>


                    <lg-form-const-select sm="2" label="Situação:" v-model="form.situacao"
                        :options="form.optionsFilterSituacao" @change="load" />

                    <lg-form-const-select label="Relacionado:" v-model="form.relacionado" sm="2"
                        :options="form.optionsFilterRelacionado" @change="load" />

                    <lg-form-input sm="4" invalidFeedback="O número processo deve ser informado!" description=""
                        v-model="form.nroSerie" label="Nº Série:" />
                    <lg-form-input sm="4" invalidFeedback="O número processo deve ser informado!" description=""
                        v-model="form.numero" label="Número:" />

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageSubgrupoProduto @onSelect="subgrupoSelect" v-model="form.subgrupo"
                            :prefix="prefix + title + ' > '" id="finderPageSubgrupo" label="SubGrupo:"
                            invalidFeedback="Marca deve ser informada!" cols="12" fromItemBemPermanenteList />
                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageClasse @onselect="classeSelect" v-model="form.classe"
                            :prefix="prefix + title + ' > '" id="finderClasse" label="Classe:"
                            invalidFeedback="Modelo deve ser informado!" />
                    </b-col>

                    <b-col lg="6" sm="12" class="text-left">
                    </b-col>

                    <b-col lg="2" sm="12" class="text-right">
                        <img id="xlsRelatorioGeral" @click="relatorioGeralIBP" :src="icon" class="img img--clickable"
                            alt="XLS" />
                        <b-tooltip target="xlsRelatorioGeral" title="Relatório Geral de IBP"
                            triggers="hover"></b-tooltip>

                        <img id="xlsRelatorioGeral-simplificado" @click="relatorioGeralIBPSimplificado" :src="icon"
                            class="img img--clickable" alt="XLS" />
                        <b-tooltip target="xlsRelatorioGeral-simplificado" title="Relatório Geral de IBP Simplificado"
                            triggers="hover"></b-tooltip>

                    </b-col>


                    <b-col cols="12">
                        <b-form-checkbox class="d-flex justify-content-end mr-4" v-model="form.distribuicao"
                            @change="onDistribuicaoChange" :value="1" :unchecked-value="0">
                            Itens no prazo limite de distribuição
                        </b-form-checkbox>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols="12" class="text-right">
                        <b-button id="LimparIbp" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="LimparIbp" title="Limpar" triggers="hover"></b-tooltip>
                        </b-button>

                        <b-button id="pesquisaIbp" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="pesquisaIbp" title="Localizar" triggers="hover"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <div class="table-container"
                    style="overflow: visible !important; max-height: none !important; position: relative !important; user-select: none !important; -webkit-user-select: none !important; -moz-user-select: none !important; -ms-user-select: none !important; touch-action: pan-y !important; -webkit-touch-callout: none !important; padding-bottom: 50px !important; border: none !important;">
                    <b-table id="tabelaItem" responsive class="mt-2" small :busy="this.busy" :items="this.records"
                        :fields="this.tableFields" :hover="true" @row-dblclicked="itemBemPermanenteSelect"
                        @row-cliked="itemBemPermanenteSelect" show-empty
                        style="user-select: none !important; -webkit-user-select: none !important; -moz-user-select: none !important; -ms-user-select: none !important; touch-action: pan-y !important; -webkit-touch-callout: none !important;">
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>
                        <template #empty>
                            <p>Nenhum resultado encontrado</p>
                        </template>
                        <template v-slot:cell(action)="data">

                            <b-button :id="data.index + 'edit-button'" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="visualizarConsulta(data.item, true)">
                                <b-icon v-b-tooltip.hover.top="'Editar'" icon="pencil-square" />

                            </b-button>

                            <b-button :id="data.index + 'visualizar-button'" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="visualizarConsulta(data.item, false)">
                                <b-icon icon="eye" v-b-tooltip.hover.top="'Visualizar'" />
                            </b-button>


                        </template>
                        <template v-slot:cell(advanced)="{ item }">
                            <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
                                <lg-button-acoes :iconeLista="true" :actions="actionsBtnAdvanced(item)"
                                    :itemRecord="item"></lg-button-acoes>
                            </div>
                        </template>
                        <template v-slot:cell(relacionado)="{ item }">
                            <span>{{ item.relacionado === 1 ? "Sim" : "Não" }}</span>
                        </template>
                        <template v-slot:cell(bloqueado)="row">
                            <b-button :id="'bloqueado' + row.index" class="text-danger p-0 mx-1" variant="link"
                                v-if="row.item.bloqueado === 1">
                                <b-icon v-b-tooltip.hover.top="'Bloqueado'" icon="dash-circle-fill" />
                            </b-button>

                            <b-button :id="'agregado-btn' + row.index" class="text-warning p-0 mx-1" variant="link"
                                v-if="row.item.agregacaoString">
                                <b-icon v-b-tooltip.hover.top="row.item.agregacaoString" icon="link-45deg" />
                            </b-button>

                            <b-button :id="'solmanutencaobtn' + row.index" class='p-0 mx-1' variant="link"
                                v-if="row.item.solicitacaoString">
                                <b-icon icon="wrench" v-b-tooltip.hover.top="row.item.solicitacaoString" />

                            </b-button>
                        </template>
                    </b-table>
                </div>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ModalHistoricoAlteracaoList :prefix="prefix + title + ' > '" v-if="mostrarModal" :id="idItemBemPermanente"
            @fecharModal="fecharModal">
        </ModalHistoricoAlteracaoList>

        <ModalHistoricoCoResponsavel :prefix="prefix + title + ' > '" v-if="mostrarModalHistoricoCoResponsavel"
            :id="idItemBemPermanente" @fecharModal="fecharModal">
        </ModalHistoricoCoResponsavel>

        <ModalHistoricoSenado v-if="mostrarModalHistoricoSenado" :id="idItemBemPermanente" @fecharModal="fecharModal">
        </ModalHistoricoSenado>

        <ModalHistoricoMonitoramento v-if="mostrarModalHistoricoMonitoramento" :id="idItemBemPermanente"
            @fecharModal="fecharModal">
        </ModalHistoricoMonitoramento>



        <ModalEstadoConservacaoIBP :prefix="prefix + title + ' > '" v-if="mostrarModalEstadoConservacao"
            :id="idItemBemPermanente" @fecharModal="fecharModal">
        </ModalEstadoConservacaoIBP>

        <ModalRelatorioDepreciacao v-if="mostrarModalRelatorioDepreciacao" :id="idItemBemPermanente"
            @fecharModal="fecharModal" :prefix="prefix + title + ' > '">
        </ModalRelatorioDepreciacao>
        <ModalFotoIBP v-if="mostrarModalFotoIBP" :id="idItemBemPermanente" @fecharModal="fecharModal"
            :prefix="prefix + title + ' > '"></ModalFotoIBP>
        <ModalFotoProdutoAlmoxarifado :prefix="prefix + title" v-if="mostrarModalFotoProdutoIBP"
            :id="idItemBemPermanenteProduto" @fecharModal="fecharModal">
        </ModalFotoProdutoAlmoxarifado>
        <ModalDocumentoIBP v-if="mostrarModalDocumentoIBP" :id="idItemBemPermanente" @fecharModal="fecharModal">
        </ModalDocumentoIBP>
        <ModalApoliceSeguroIBP v-if="mostrarModalApoliceSeguroIBP" :prefix="prefix + title" :id="idItemBemPermanente"
            @fecharModal="fecharModal">
        </ModalApoliceSeguroIBP>
        <ModalItemBemPermanenteView v-if="mostrarConsultaIBP" :isEdit="isEdit" :id="idItemBemPermanente"
            @fecharModal="fecharModal" />
        <ModalAgregacaoItemBemPermanente v-if="mostrarModalAgregacao" :Ibp="IbpSelecionado" @fecharModal="fecharModal"
            :prefix="prefix + title + ' > '" />
        <ModalReavaliacao v-if="mostrarModalReavaliacao" :prefix="prefix + title" :ItemBemPermanente='IbpSelecionado'
            @fecharModal="fecharModal" />
        <LgFinderPageSolicitacaoManutencaoPatrimonial :idItemBemPermanente="idItemBemPermanente"
            v-if='mostrarSolicitacaoManutencaoPatrimonial' :modalOnly='true' :prefix="[prefix + title]"
            @input="fecharModal" />
        <ModalOperacaoIbp v-if="mostrarModalOperacao" :prefix="[prefix + title]" :id="idItemBemPermanente"
            @close="fecharModal" />
        <ModalObservacaoItemBemPermanente v-if="mostrarModalObservacao" :prefix="[prefix + title]"
            :id="idItemBemPermanente" @close="fecharModal" />

        <ModaLocalProibidoItemBemPermanente v-if="mostrarModalLocalProibido" :prefix="[prefix + title]"
            :id="idItemBemPermanente" @close="fecharModal" />


    </b-card>
</template>
<script>
import XLSIcon from "@/core/assets/icons/xls.png";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil"

import LgFinderPageClasse from '@/components/Finders/LgFinderPageClasse.vue'
import LgFinderPageEmpenho from "@/components/Finders/LgFinderPageEmpenho.vue"
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue"
import LgFinderPageMarca from "@/components/Finders/LgFinderPageMarca.vue"
import LgFinderPageModelo from "@/components/Finders/LgFinderPageModelo.vue"
import LgFinderPageNatureza from "@/components/Finders/LgFinderPageNatureza.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import LgFinderPageStatus from '@/components/Finders/LgFinderPageStatus.vue'
import LgFinderPageSubgrupoProduto from '@/components/Finders/LgFinderPageSubgrupoProduto.vue'
import LgFinderPageTipoEstadoConservacao from "@/components/Finders/LgFinderPageTipoEstadoConservacao.vue"
import LgFinderPageUnidadeAdministrativa from '@/components/Finders/LgFinderPageUnidadeAdministrativa.vue'
import ResourceService from "@/core/api/ResourceService"
import LgButtonAcoes from "@/core/components/Form/LgButtonAcoes.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalApoliceSeguroIBP from "@/core/components/Modals/ModalApoliceSeguroIBP.vue"
import ModalDocumentoIBP from '@/core/components/Modals/ModalDocumentoIBP.vue'
import ModalEstadoConservacaoIBP from "@/core/components/Modals/ModalEstadoConservacaoIBP"
import ModalFotoIBP from "@/core/components/Modals/ModalFotoIBP"
import ModalFotoProdutoAlmoxarifado from '@/core/components/Modals/ModalFotoProdutoAlmoxarifado.vue'
import ModalHistoricoAlteracaoList from "@/core/components/Modals/ModalHistoricoAlteracaoList.vue"
import ModalHistoricoSenado from "@/core/components/Modals/ModalHistoricoSenado.vue"
import ModalHistoricoMonitoramento from "@/core/components/Modals/ModalHistoricoMonitoramento.vue";

import ModalReavaliacao from '@/core/components/Modals/ModalReavaliacao.vue'
import ModalRelatorioDepreciacao from "@/core/components/Modals/ModalRelatorioDepreciacao.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import LgFinderPageSolicitacaoManutencaoPatrimonial from '@/components/Finders/LgFinderPageSolicitacaoManutencaoPatrimonial.vue'
import ModalAgregacaoItemBemPermanente from '@/core/components/Modals/ModalAgregacaoItemBemPermanente.vue'
import ModalItemBemPermanenteView from '@/core/components/Modals/ModalItemBemPermanenteView.vue'
import ModalObservacaoItemBemPermanente from '@/core/components/Modals/ModalObservacaoItemBemPermanente.vue'
import ModalOperacaoIbp from '@/core/components/Modals/ModalOperacaoIbp.vue'
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModaLocalProibidoItemBemPermanente from '@/core/components/Modals/ModaLocalProibidoItemBemPermanente.vue'
import ModalHistoricoCoResponsavel from "@/core/components/Modals/ModalHistoricoCoResponsavel.vue";

export default {
    name: "ItemBemPermanenteList",
    components: {
        ModalHistoricoMonitoramento,
        ModalHistoricoCoResponsavel,
        ModaLocalProibidoItemBemPermanente,
        LgFinderPageUnidadeAdministrativa,
        ModalItemBemPermanenteView,
        ModalObservacaoItemBemPermanente,
        ModalOperacaoIbp,
        ModalAgregacaoItemBemPermanente,
        ModalApoliceSeguroIBP,
        ModalHistoricoAlteracaoList,
        ModalHistoricoSenado,
        ModalRelatorioDepreciacao,
        ModalFotoIBP,
        ModalReavaliacao,
        ModalFotoProdutoAlmoxarifado,
        LgFormInput,
        LgFormDate,
        LgFinderPagePessoa,
        LgFormConstSelect,
        ModalEstadoConservacaoIBP,
        LgFinderPageLocalArmazenamento,
        LgButtonAcoes,
        ModalDocumentoIBP,
        LgFinderPageTipoEstadoConservacao,
        LgFinderPageEmpenho,
        LgFinderPageMarca,
        LgFinderPageModelo,
        LgFinderPageNatureza,
        LgFinderPageClasse,
        LgFinderPageSubgrupoProduto,
        LgFinderPageStatus,
        LgFinderPageSolicitacaoManutencaoPatrimonial,
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        isAbertoFromModal: {
            type: Boolean,
            default: false
        },
        podeMudarDepartamento: {
            type: Boolean,
            default: true
        },
        prefix: {
            tipe: String,
            default: "",
        },
        podePegarBloqueado: {
            type: Boolean,
            default: false,
        }
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/itembempermanente`)
        this.$statusService = new ResourceService(`/api/status/tipo/6`)
        this.$serviceStatus = new ResourceService(`/api/status`)

        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento
        this.params.departamentoId = brand.departamento.id

        this.load()
        this.preventDrag()

    },
    data() {
        return {
            codsDepartamentos: "",
            idItemBemPermanenteProduto: null,
            icon: XLSIcon,
            selecionarTodos: false,
            mostrarModal: false,
            mostrarModalDocumentoIBP: false,
            mostrarModalEstadoConservacao: false,
            mostrarModalRelatorioDepreciacao: false,
            mostrarModalHistoricoSenado: false,
            mostrarModalHistoricoMonitoramento: false,
            mostrarModalFotoIBP: false,
            mostrarModalFotoProdutoIBP: false,
            mostrarModalApoliceSeguroIBP: false,
            mostrarModalHistoricoCoResponsavel: false,
            mostrarConsultaIBP: false,
            mostrarModalAgregacao: false,
            mostrarModalReavaliacao: false,
            mostrarSolicitacaoManutencaoPatrimonial: false,
            mostrarModalOperacao: false,
            mostrarModalObservacao: false,
            mostrarModalLocalProibido: false,
            idItemBemPermanente: null,
            isEdit: false,
            IbpSelecionado: null,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            title: this.$route.meta.description,
            form: {
                notInUnidadeAdministrativa: false,
                incluirFilhos: 1,
                pessoa: {},
                pessoas: [],
                produto: {},
                produtos: [],
                id: "",
                s_numTombAntigo: "",
                numeroProcesso: "",
                descricaoProduto: "",
                nroContrato: "",
                localArmazenamento: {},
                tipoestadoconservacao: {},
                dataDe: "",
                dataAte: "",
                complemento: "",
                notaFiscal: "",
                status: {},
                responsavel: {},
                numTombamentoDe: "",
                numTombamentoSamp: "",
                departamento: {},
                natureza: {},
                numero: "",
                classe: {},
                subgrupo: {},
                empenho: {},
                modelo: {},
                marca: {},
                descricaoExata: false,

                situacao: "1",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

                relacionado: null,
                optionsFilterRelacionado: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Sim", value: "1" },
                    { key: "filterSituacao", text: "Não", value: "0" },
                ],
            },
        }
    },

    watch: {
        page() {
            this.load()
        },

        "form.situacao"() {
            this.load()
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "bloqueado",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "numTombamento",
                    label: "Tombamento",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "s_numTombAntigo",
                    label: "Tombamento SAMP",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "numero",
                    label: "Número",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "",
                },
                {
                    key: "descricaoResumida",
                    label: "Descrição",
                    thStyle: "font-size: 14px; font-weight: 400; max-width: 100px !important",
                    tdStyle: "font-size: 13px; max-width: 100px !important",
                },
                {
                    key: "relacionado",
                    label: "BR",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "dataEntrada",
                    label: "Data Aquisição",
                    formatter: (data) => data && (String(data))?moment(String(data)).format("DD/MM/YYYY"):"",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "valorOriginal",
                    label: "Valor Aquisição (R$)",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    formatter: (value) => {

                        return !value ? "" : value.toLocaleString("pt-BR", {
                            style: "decimal",
                            currency: "BRL",
                            minimumFractionDigits: 2,
                        })
                    },
                },
                {
                    key: "action",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "advanced",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
            ]
        },
    },
    methods: {
        preventDrag() {
            this.$nextTick(() => {
                const tableContainer = document.querySelector('.table-container');
                if (tableContainer) {
                    tableContainer.addEventListener('dragstart', (e) => {
                        e.preventDefault();
                        return false;
                    });

                    tableContainer.addEventListener('drag', (e) => {
                        e.preventDefault();
                        return false;
                    });

                    tableContainer.addEventListener('selectstart', (e) => {
                        if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
                            e.preventDefault();
                            return false;
                        }
                    });

                    tableContainer.addEventListener('touchstart', (e) => {
                        if (e.touches.length > 1) {
                            e.preventDefault();
                        }
                    }, { passive: false });
                }
            });
        },
        selecionarOrnograma(departamentos) {

            this.codsDepartamentos = departamentos;
            this.load();
        },
        verificaPrivilegioGerenciarPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO)
        },
        verificaPrivilegioLocaisProibidos() {
            return verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_PODE_INSERIR_LOCAIS_NAO_AUTORIZADOS)
        },

        actionsBtnAdvanced(ibp) {

            var opcoes = [
                {
                    acao: this.visualizarModalHistoricoCoResponsavel,
                    label: "Co Responsável",
                    icon: "person",
                    type: "function",
                },

                {
                    acao: this.visualizarModal,
                    label: "Histórico",
                    icon: "clock",
                    type: "function",
                },
                {
                    acao: this.visualizarModalHistoricoSenado,
                    label: "Histórico Senado",
                    icon: "clock-fill",
                    type: "function",
                },
                {
                    acao: this.visualizarModalHistoricoMonitoramento,
                    label: "Histórico Monitoramento",
                    icon: "camera-fill",
                    type: "function",
                },
            ]


            if (this.verificaPrivilegioLocaisProibidos())
                opcoes.push({ label: "Locais Proibidos", icon: "x-circle-fill", acao: this.visualizarModalLocalProibido, type: "function" });

            if (ibp.bloqueado == 1 && verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_DESBLOQUEIO))
                opcoes.push({ label: "Desbloqueio", icon: "dash-circle-fill", acao: this.visualizarModalObservacao, type: "function" });



            if (verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_MANUTENCAO_ACESSAR))
                opcoes.push({
                    acao: this.visualizarModalObservacao,
                    label: "Observações",
                    icon: "exclamation-triangle",
                    type: "function",
                });

            if (verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_AVALIACAO_ACESSAR))
                opcoes.push({
                    acao: this.visualizarModalEstadoConservacao,
                    label: "Avaliação de Estado",
                    icon: "display",
                    type: "function",
                });


            if (verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ACESSAR_FOTO_PRODUTO))
                opcoes.push({
                    acao: this.visualizarmostrarModalFotoIBP,
                    label: "Foto IBP",
                    icon: "card-image",
                    type: "function",
                });

            if (verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ACESSAR_FOTO_PRODUTO))
                opcoes.push({
                    acao: this.visualizarModalFotoProdutoIBP,
                    label: "Foto do Produto",
                    icon: "card-image",
                    type: "function",
                });

            if (verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_MANUTENCAO_ACESSAR))
                opcoes.push({
                    acao: this.visualizarSolicitacaoManutencaoPatrimonial,
                    label: "Manutenções",
                    icon: "wrench",
                    type: "function",
                });

            if (verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_DEPRE_VAL_ACESSAR))
                opcoes.push({
                    acao: this.visualizarModalReavaliacao,
                    label: "Reavaliação de Valor",
                    icon: "arrow-down-up",
                    type: "function",
                });

            if (!ibp.agregacaoString && verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_AGREGACAO))
                opcoes.push({
                    acao: this.visualizarModalAgregacao,
                    label: "Agregação",
                    icon: "link",
                    type: "function",
                    show: (item) => item.bloqueado == 0,
                });

            if (verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_OPERACOES_ACESSAR))
                opcoes.push({
                    acao: this.visualizarModalOperacao,
                    label: "Operações",
                    icon: "diagram3",
                    type: "function",
                });

            if (!ibp.agregacaoString && ibp.bloqueado == 0 && verificaPrivilegio(PrivilegiosEnum.APOLICE_SEGURO_ACESSAR)) {
                opcoes.push({
                    acao: this.visualizarModalApoliceSeguroIBP,
                    label: "Seguro - Apólice",
                    icon: "cash-coin",
                    type: "function",
                },
                )
            }

            if (verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_DOCUMENTOS_ACESSAR))
                opcoes.push({
                    acao: this.visualizarModalDocumentoIBP,
                    label: "Documentos",
                    icon: "file-earmark-fill",
                    type: "function",
                });

            if (verificaPrivilegio(PrivilegiosEnum.DEPRECIACAO_IBP_GERAR_RELATORIO))
                opcoes.push({
                    acao: this.visualizarModalRelatorioDepreciacao,
                    label: "Relatório de Depreciação",
                    icon: "file-pdf",
                    type: "function",
                });

            return opcoes.sort((opcao1, opacao2) => opcao1.label.localeCompare(opacao2.label));
        },


        manageNotInUnidadeAdministrativa(notInUnidadeAdministrativa) {
            this.form.notInUnidadeAdministrativa = notInUnidadeAdministrativa;
            this.load();
        },
        selectFillhoClicked(valor) {
            this.form.incluirFilhos = valor;
            this.load();
        },
        async relatorioGeralIBP() {
            this.busy = true;
            this.gerarFiltro();
            this.params.isSimplificado = false;

            var { data } = await this.$service.put("relatorioGeralIBP", this.params);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.load();

        },
        async relatorioGeralIBPSimplificado() {
            this.busy = true;
            this.gerarFiltro();
            this.params.isSimplificado = true;

            var { data } = await this.$service.put("relatorioGeralIBPSimplificado", this.params);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.load();

        },
        async onDistribuicaoChange() {
            try {
                var { data } = await this.$service.getWithParams('listarItensDoDepartamentoNoPatrimonio', {
                    params: {
                        size: this.perPage,
                        page: this.page,
                    }
                });
                this.itens = data
            } catch (error) {
                this.form.distribuicao = 0;
                this.$notify({
                    type: "danger",
                    message: error.response.data
                })

            }
        },

        gerarFiltro() {
            this.params = {}

            this.params.notInUnidadeAdministrativa = this.form.notInUnidadeAdministrativa;

            this.params.incluirFilhos = this.form.incluirFilhos;
            if (this.form.distribuicao) {
                this.params.itensNoPrazoLimite = this.form.distribuicao == 1 ? true : false;
            }

            if (this.codsDepartamentos != "") {
                this.params.codsDepartamentos = this.codsDepartamentos;
            }

            this.params.relacionado = null;
            if (this.form.relacionado) {
                this.params.relacionado = this.form.relacionado;
            }

            if (this.form.responsavel && this.form.responsavel.id) {
                this.params.utilizadoPor = this.form.responsavel.id
            }

            this.params.numTombamentoDe = null
            this.params.numTombamentoAte = null


            if (
                this.form.numTombamentoDe &&
                this.form.numTombamentoDe != ""
            ) {
                this.params.numTombamentoDe = this.form.numTombamentoDe;
            }

            if (
                this.form.numTombamentoAte &&
                this.form.numTombamentoAte != ""
            ) {
                this.params.numTombamentoAte = this.form.numTombamentoAte;
            }

            if (this.form.natureza && this.form.natureza.id)
                this.params.naturezaId = this.form.natureza.id

            this.params.numTombamentoSAMP = null
            if (this.form.numTombamentoSamp) {
                this.params.numTombamentoSAMP = this.form.numTombamentoSamp
            }

            this.params.dataInicio = null
            this.params.dataFim = null
            if (this.form.dataDe && this.form.dataAte) {
                this.params.dataInicio = moment(String(this.form.dataDe)).format(
                    "DD/MM/YYYY"
                )
                this.params.dataFim = moment(String(this.form.dataAte)).format(
                    "DD/MM/YYYY"
                )
            }


            if (this.form.departamento) {
                this.params.departamentoId = this.form.departamento.id;
            }

            this.params.descricao = null
            if (this.form.descricaoProduto) {
                this.params.descricao = this.form.descricaoProduto
            }

            this.params.descricaoExata = this.form.descricaoExata

            this.params.produtoId = null
            if (this.form.produto && Object.keys(this.form.produto).length > 0) {
                this.params.produtoId = this.form.produto
            }

            this.params.numProcesso = null
            if (this.form.numeroProcesso) {
                this.params.numProcesso = this.form.numeroProcesso
            }

            this.params.numContrato = null
            if (this.form.nroContrato) {
                this.params.numContrato = this.form.nroContrato
            }

            this.params.statusId = null
            if (this.form.status && this.form.status.id) {
                this.params.statusId = this.form.status.id
            }

            this.params.numSerie = null
            if (this.form.nroSerie) {
                this.params.numSerie = this.form.nroSerie
            }

            this.params.situacao = null
            if (this.form.situacao) {
                this.params.situacao = this.form.situacao
            }

            this.params.classeId = null
            if (this.form.classe && this.form.classe.id) {
                this.params.classeId = this.form.classe.id
            }

            this.params.subGrupoProdutoId = null
            if (this.form.subgrupo && this.form.subgrupo.id) {
                this.params.subGrupoProdutoId = this.form.subgrupo.id
            }

            this.params.localArmazenamentoId = null
            if (this.form.localArmazenamento && this.form.localArmazenamento.id) {
                this.params.localArmazenamentoId = this.form.localArmazenamento.id
            }

            this.params.numeroEmpenho = null
            if (this.form.empenho && this.form.empenho.id) {
                this.params.numeroEmpenho = this.form.empenho.numero
            }

            this.params.marcaId = null
            if (this.form.marca && this.form.marca.id) {
                this.params.marcaId = this.form.marca.id
            }

            this.params.modeloId = null
            if (this.form.modelo && this.form.modelo.id) {
                this.params.modeloId = this.form.modelo.id
            }

            this.params.tipoEstadoConservacaoId = null
            if (this.form.tipoestadoconservacao && this.form.tipoestadoconservacao.id) {
                this.params.tipoEstadoConservacaoId = this.form.tipoestadoconservacao.id
            }

            this.params.numeroProduto = null
            if (this.form.numero) {
                this.params.numeroProduto = this.form.numero
            }

        },

        async load() {
            this.busy = true

            this.gerarFiltro();
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            })
            this.busy = false
        },
        async removerResource(item) {
            this.$removeResource(item)
        },
        async statusList({ filter, page = 1 }) {
            return this.$serviceStatus.findAll({ filter, page, limit: 5 })
        },
        async listStatus({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 })
        },
        async itemBemPermanenteSelect(item) {

            if (this.isAbertoFromModal) {

                if (item.bloqueado && !this.podePegarBloqueado)
                    this.$notify({
                        type: "danger",
                        message: "Item Bem Permanente Bloqueado",
                    });
                else
                    this.$emit("onDblClickItemBemPermanente", item)

            }
            else {
                this.visualizarConsulta(item, false);
            }


        },
        clearForm() {
            this.codsDepartamentos = "";
            this.form.dataDe = "";
            this.form.dataAte = "";
            this.form.numTombamentoDe = ""
            this.form.numTombamentoAte = ""
            this.form.numTombamentoSamp = ""
            this.form.numeroSerie = ""
            this.form.situacao = "1"
            this.form.complemento = ""
            this.form.empenho = {}
            this.form.nroProcesso = ""
            this.form.modelo = {}
            this.form.marca = {}
            this.form.nroSerie = ""
            this.form.numero = ""
            this.form.nroContrato = ""
            this.form.natureza = {}
            this.form.responsavel = {}
            this.form.classe = {}
            this.form.subgrupo = {}
            this.form.descricaoExata = false
            this.form.localArmazenamento = {}
            this.form.tipoestadoconservacao = {}
            this.form.descricaoProduto = ""
            this.form.relacionado = null
            this.params = {}
            const brand = JSON.parse(localStorage.getItem("context"))

            if (verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO)) {
                this.form.departamento = {};
            }

            this.params.departamentoId = brand.departamento.id
            this.load()
        },
        fecharModal() {
            this.mostrarModal = false
            this.mostrarModalFotoIBP = false
            this.mostrarModalFotoProdutoIBP = false
            this.mostrarModalEstadoConservacao = false
            this.mostrarModalRelatorioDepreciacao = false
            this.mostrarModalHistoricoSenado = false
            this.mostrarModalHistoricoMonitoramento = false
            this.mostrarModalDocumentoIBP = false
            this.mostrarModalApoliceSeguroIBP = false
            this.mostrarModalHistoricoCoResponsavel = false
            this.mostrarConsultaIBP = false
            this.mostrarModalAgregacao = false
            this.mostrarModalReavaliacao = false
            this.mostrarSolicitacaoManutencaoPatrimonial = false
            this.mostrarModalOperacao = false
            this.mostrarModalObservacao = false
            this.mostrarModalLocalProibido = false;
            this.idItemBemPermanenteProduto = null;
            this.load();
        },
        visualizarConsulta(item, isEdit) {
            this.idItemBemPermanente = item.id
            this.isEdit = isEdit
            this.mostrarConsultaIBP = true
        },
        visualizarModalOperacao(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalOperacao = true
        },

        visualizarModalLocalProibido(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalLocalProibido = true
        },

        visualizarModalObservacao(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalObservacao = true
        },
        visualizarModalAgregacao(item) {
            this.IbpSelecionado = item
            this.mostrarModalAgregacao = true
        },
        visualizarModal(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModal = true

        },
        visualizarModalReavaliacao(item) {
            this.IbpSelecionado = item
            this.mostrarModalReavaliacao = true
        },
        visualizarSolicitacaoManutencaoPatrimonial(item) {
            this.idItemBemPermanente = item.id
            this.mostrarSolicitacaoManutencaoPatrimonial = true
        },
        visualizarModalDocumentoIBP(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalDocumentoIBP = true
        },
        visualizarModalHistoricoSenado(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalHistoricoSenado = true

        },
        visualizarModalHistoricoMonitoramento(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalHistoricoMonitoramento = true

        },
        visualizarmostrarModalFotoIBP(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalFotoIBP = true
        },
        visualizarModalFotoProdutoIBP(item) {
            this.idItemBemPermanenteProduto = item.idProduto
            this.mostrarModalFotoProdutoIBP = true
        },

        visualizarModalEstadoConservacao(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalEstadoConservacao = true

        },
        visualizarModalApoliceSeguroIBP(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalApoliceSeguroIBP = true
        },
        visualizarModalHistoricoCoResponsavel(item) {
            this.idItemBemPermanente = item.id;
            this.mostrarModalHistoricoCoResponsavel = true;
        },
        visualizarModalRelatorioDepreciacao(item) {
            this.idItemBemPermanente = item.id
            this.mostrarModalRelatorioDepreciacao = true

        },
        selectTipoEstado(item) {
            this.form.tipoestadoconservacao = item
            this.load()
        },
        selectEmpenho(item) {
            this.form.empenho = item
            this.load()
        },
        selectModelo(item) {
            this.form.modelo = item
            this.load()
        },
        localArmazenamentoSelect(item) {
            this.form.localArmazenamento = item
            this.load()
        },
        marcaSelect(item) {
            this.form.marca = item
            this.load()
        },
        naturezaSelect(item) {
            this.form.natureza = item
            this.load()
        },
        selectStatus(item) {
            this.form.status = item
            this.load()
        },
        responsavelSelect(item) {
            this.form.responsavel = item
            this.load()
        },
        departamentoSelect(item) {
            this.codsDepartamentos = "";
            this.form.departamento = item
            this.load()
        },
        subgrupoSelect(item) {
            this.form.subgrupo = item
            this.load()
        },
        classeSelect(item) {
            this.form.classe = item
            this.load()
        }
    },
}
</script>

<style scoped>
/* Container da tabela para controlar o scroll */
.table-container {
    position: relative;
    overflow: visible;
    max-height: none;
    border: none;
    border-radius: 0;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    touch-action: pan-y;
    -webkit-touch-callout: none;
    padding-bottom: 50px;
    /* Espaço extra para dropdowns */
}

/* Permitir scroll na tabela responsiva dentro do container */
.table-container .table-responsive {
    overflow: visible !important;
    max-height: none !important;
    height: auto !important;
    padding-bottom: 50px !important;
}

/* Controlar o scroll da tabela */
.table-container .table {
    margin-bottom: 0 !important;
    width: 100% !important;
    table-layout: auto;
    height: auto !important;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    touch-action: pan-y;
    -webkit-touch-callout: none;
}

/* Prevenir comportamento de arrastar na tabela */
#tabelaItem {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    touch-action: pan-y !important;
    -webkit-touch-callout: none !important;
    -webkit-user-drag: none !important;
    -khtml-user-drag: none !important;
    -moz-user-drag: none !important;
    -o-user-drag: none !important;
    user-drag: none !important;
}

/* Permitir seleção de texto apenas nas células */
#tabelaItem td {
    user-select: text !important;
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Permitir tooltips aparecerem corretamente */
#tabelaItem td {
    overflow: visible !important;
    position: relative;
    z-index: 1;
}

/* Regra específica para elementos com tooltip direto */
#tabelaItem td [v-b-tooltip],
#tabelaItem td b-icon[v-b-tooltip],
#tabelaItem td button[v-b-tooltip] {
    position: relative;
    z-index: 2;
}

/* Garantir que tooltips não sejam cortados */
#tabelaItem .tooltip {
    z-index: 9999 !important;
    position: absolute !important;
}

/* Prevenir arrastar em botões e elementos interativos */
#tabelaItem button,
#tabelaItem .btn,
#tabelaItem .dropdown,
#tabelaItem .dropdown-toggle {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    touch-action: manipulation !important;
}

/* Garantir que o dropdown não cause problemas de layout */
#tabelaItem .dropdown-menu {
    position: absolute !important;
    z-index: 1050 !important;
    max-height: 300px;
    overflow-y: auto;
}

/* Scrollbar personalizada para o container */
.table-container::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* SOLUÇÃO PARA DROPDOWNS EM TABELAS - SEM QUEBRAR O LAYOUT */
/* Garantir que apenas a célula com dropdown tenha overflow visible */
#tabelaItem tbody tr td:last-child {
    overflow: visible !important;
    position: relative;
    z-index: 10;
    white-space: nowrap !important;
}

/* Prevenir que outras células tenham overflow visible */
#tabelaItem tbody tr td:not(:last-child) {
    overflow: hidden !important;
}

/* Garantir que dropdowns apareçam corretamente */
#tabelaItem tbody tr td .dropdown-menu {
    position: absolute !important;
    z-index: 9999 !important;
    max-height: 300px;
    overflow-y: auto;
    min-width: 200px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    right: 0 !important;
    left: auto !important;
    top: 100%;
    margin-top: 2px;
    transform: translateX(100%) !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
}

/* Prevenir que o hover da célula interfira com o dropdown */
#tabelaItem tbody tr td:last-child:hover {
    white-space: nowrap !important;
    overflow: visible !important;
    z-index: 11;
}

/* Garantir que dropdown sempre apareça à esquerda para não sair da tela */
#tabelaItem tbody tr td:last-child .dropdown-menu {
    right: 0 !important;
    left: auto !important;
    transform: translateX(100%) !important;
    margin-left: 0 !important;
}

/* Forçar dropdown a aparecer à esquerda do botão */
#tabelaItem tbody tr td:last-child .dropdown {
    position: relative;
}

#tabelaItem tbody tr td:last-child .dropdown-menu.show {
    right: 0 !important;
    left: auto !important;
    transform: translateX(100%) !important;
    margin-left: 0 !important;
}

/* Garantir que o container da tabela permita dropdowns */
#tabelaItem {
    position: relative;
    overflow: visible;
}

/* Ajustar posicionamento do dropdown para não sair da tela */
#tabelaItem tbody tr td .dropdown-menu {
    transform: translateX(-50%);
    left: 50%;
}

/* Para dropdowns que ficam muito à direita, ajustar posição */
#tabelaItem tbody tr td:last-child .dropdown-menu {
    right: 0;
    left: auto;
    transform: none;
}

/* Garantir que o container da tabela permita scroll interno */
.table-container {
    overflow: auto !important;
}

/* Prevenir arrastar em toda a estrutura da tabela */
.table-container * {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    touch-action: pan-y !important;
    -webkit-touch-callout: none !important;
}

/* Permitir seleção de texto apenas nas células de dados */
.table-container .table td {
    user-select: text !important;
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
}

/* Permitir interação com botões e dropdowns */
.table-container .btn,
.table-container .dropdown-toggle,
.table-container .dropdown-menu {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    touch-action: manipulation !important;
    -webkit-touch-callout: none !important;
}
</style>
